import { types } from '../actions/types';

const DEFAULT_STATE = {
    showToolbar: true
}

export default (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case types.SHOW_TOOLBAR:
            // console.log(`%cStart Photo Upload Spinner Reducer Triggered`,'color: greenyellow');
            return {...state, showToolbar: true };
        case types.HIDE_TOOLBAR:
            // console.log(`%cStop Photo Upload Spinner Reducer Triggered`,'color: greenyellow');
            return {...state, showToolbar: false };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/toolbar-reducer.js